import { Icon } from '@chakra-ui/react';

export default function SFFocusIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width='16px'
      height='17px'
      fill='currentColor'
      viewBox='0 0 16 17'
      {...props}
    >
      <path d='M.977 5.695c-.399 0-.625-.234-.625-.64V3.14Q.354.726 2.805.727H4.71c.414 0 .64.218.64.625 0 .406-.226.632-.64.632H2.82c-.782 0-1.212.414-1.212 1.227v1.844c0 .406-.218.64-.632.64m14.039 0c-.399 0-.625-.234-.625-.64V3.21c0-.813-.446-1.227-1.22-1.227h-1.89c-.406 0-.633-.226-.633-.632s.227-.625.633-.625h1.914q2.451 0 2.453 2.414v1.914c0 .406-.218.64-.632.64M4.383 8.367c0-.39.265-.664.672-.664h2.297V5.406c0-.398.257-.664.64-.664.399 0 .664.266.664.664v2.297h2.305c.398 0 .664.274.664.664 0 .383-.273.649-.664.649H8.656v2.304c0 .39-.265.664-.664.664-.383 0-.64-.273-.64-.664V9.016H5.055c-.399 0-.672-.266-.672-.649m-1.578 7.649q-2.451.002-2.453-2.422v-1.906c0-.415.218-.641.625-.641.406 0 .632.226.632.64v1.844c0 .813.43 1.227 1.211 1.227h1.89c.415 0 .642.226.642.633 0 .398-.227.625-.641.625zm8.476 0c-.406 0-.633-.227-.633-.625 0-.407.227-.633.633-.633h1.89c.774 0 1.22-.414 1.22-1.227v-1.844c0-.414.218-.64.625-.64.406 0 .632.226.632.64v1.907c0 1.61-.82 2.422-2.453 2.422z' />
    </Icon>
  );
}
